<template>
    <re-b-modal ref="material_bom" header="推送物料图纸"
                no-ok-button fit-content no-close-on-backdrop
                @hide="whenHide">
        <bom-tree ref="bomTree" v-if="bomTreeLoad"
                  :material="material"
                  :parent-material="parentMaterial"
                  class="h-100"
                  enable-check enable-component-addition
                  :expend-depth="1"
                  @noBom="$refs.material_bom.hide()"
                  @componentCheck="whenMaterialCheck"
                  @gotBom="whenBomGot">
            <template #leftHeader>
                <mini-button loading-type="grow"
                             :disable="relateMaterials.length===0 || !changed"
                             :loading="saveLoading"
                             @btnClick="saveConfig()">
                    <i class="fa-solid fa-arrow-right"></i>
                    推送
                </mini-button>
                <mini-button @btnClick="$refs.drawingView.showModal()">
                    <i class="fa-regular fa-folder-open"></i>
                    查看
                </mini-button>
            </template>

            <template #component="{row}">
                <overlay-pop class="ml-auto pl-1" v-if="row.component" :ref="row.id"
                             :btn-variant="relateDocuments[row.component]?'primary':'outline-primary'"
                             btn-icon="fa-solid fa-compass-drafting"
                             btn-class="pt-0 pb-0 pl-1 pr-1"
                             trigger="focus" :btn-disable="!initFinish"
                             @shown="whenDrawingBtnClick(row)">
                    <mini-table :ref="'MT'+row.id"
                                style="min-width: 400px"
                                :loading="drawingQuerying===row.component"
                                :items="getDrawingList(row)"
                                :fields="drawingTableFields" disable-first-index-column
                                read-only row-click-check
                                :enable-row-check="!relateMaterials.some(o=>o===row.component)"
                                custom-columns="originFileName"
                                row-key="number"
                                @rowChecked="whenDocumentCheck(row.component,$event)">
                        <template #rightHeader>
                            <b-form-checkbox v-model="drawingContainsOld[row.component]" name="check-button" switch
                                             @change="whenContainsOldChange(row)">
                                包含旧图纸：<b>{{ drawingContainsOld[row.component] ? '是' : '否' }}</b>
                            </b-form-checkbox>
                        </template>
                        <template #custom(originFileName)="{row,val}">
                            <b-link @click="downloadDrawing(row.id, val)">{{ val }}</b-link>
                        </template>
                    </mini-table>
                </overlay-pop>
            </template>
        </bom-tree>

        <re-b-modal ref="drawingView" header="配置查看" no-ok-button>
            <div class="d-flex flex-column">
                <h4>物料号</h4>
                <div v-for="(item,index) of relateMaterials" :key="index" class="ml-2">
                    {{ item }}
                </div>
                <h4 class="mt-2">图纸号</h4>
                <div v-for="(val,key,index) in relateDocuments" :key="key+index">
                    <div v-for="(d,i) of val" :key="i" class="ml-2">
                        {{ key }} - {{ d }}
                    </div>
                </div>
            </div>
        </re-b-modal>
    </re-b-modal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import BomTree from "@/components/bom/BomTree.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import OverlayPop from "@/components/workflow/stuffs/OverlayPop.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import drawingDownloadMixin from "@/views/sithMesII/pds/stuffs/drawing-download-mixin";

export default {
    name: "DrawingSelectInBom",
    components: {MiniTable, OverlayPop, MiniButton, BomTree, ReBModal},
    mixins: [emCommonUtilMixin, drawingDownloadMixin],
    data() {
        return {
            bomTreeLoad: true,
            material: null,
            parentMaterial: null,
            config: {},
            relateMaterials: [],
            relateDocuments: {},
            saveLoading: false,

            gotBom: false,
            gotConfig: false,
            initFinish: false,

            materialDrawingInfo: {},
            drawingQuerying: null,
            drawingTableFields: [
                {key: 'originFileName', label: '文件名'},
                {key: 'number', label: '图纸号'},
                {key: 'version', label: '版本号'},
                {key: 'description', label: '描述'},
            ],
            drawingContainsOld: {},

            changed: false
        }
    },
    methods: {
        showModal(material = null, parentMaterial = null) {
            if (!material) {
                this.$message.warning('无效的物料号');
                return;
            }
            this.material = material;
            this.$refs.material_bom.showModal();
            if (parentMaterial) {
                this.parentMaterial = parentMaterial;
            }
            this.$nextTick(() => {
                this.bomTreeLoad = true;
                this.getCheckConfig();
            });
        },
        getCheckConfig() {
            if (this.material) {
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_SITHMESII_PDS_URL + "/materialDrawingRelate/query/config?material=" + this.material
                }).then(response => {
                    if (response) {
                        this.relateMaterials = response.relateMaterials;
                        this.relateDocuments = {};
                        for (let item of response.relateDocuments) {
                            if (this.relateDocuments.hasOwnProperty(item.material)) {
                                this.relateDocuments[item.material].push(item.documentNumber);
                            } else {
                                this.relateDocuments[item.material] = [item.documentNumber];
                            }
                        }
                        this.gotConfig = true;
                        this.initCheckedComponent();
                    }
                })
            }
        },
        saveConfig() {
            if (this.material) {
                this.saveLoading = true;
                let tempList = [];
                for (let m in this.relateDocuments) {
                    if (this.relateDocuments.hasOwnProperty(m)) {
                        for (let d of this.relateDocuments[m]) {
                            tempList.push({
                                material: m,
                                documentNumber: d,
                            })
                        }
                    }
                }
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMESII_PDS_URL + "/materialDrawingRelate/pick",
                    data: {
                        material: this.material,
                        relateMaterials: this.relateMaterials,
                        relateDocuments: tempList,
                    }
                }).then(response => {
                    console.log(response);
                    this.$message.success('保存成功');
                    this.changed = false;
                }).finally(() => this.saveLoading = false);
            }
        },
        whenBomGot() {
            this.gotBom = true;
            this.initCheckedComponent();
        },
        initCheckedComponent() {
            if (!this.initFinish && this.gotBom && this.gotConfig) {
                this.initFinish = true;
                this.$nextTick(() => this.$refs.bomTree.initCheckedComponent(this.relateMaterials));
            }
        },
        whenHide() {
            this.bomTreeLoad = false;
            this.initFinish = false;
            this.gotBom = false;
            this.gotConfig = false;
            this.materialDrawingInfo = {};
        },
        whenDrawingBtnClick(row) {
            let material = row.component;
            if (!this.materialDrawingInfo.hasOwnProperty(material)) {
                this.queryMaterialDrawingInfo(material, false, row);
            } else {
                this.initCheckedDocument(row);
            }
        },
        initCheckedDocument(row) {
            this.$nextTick(() => {
                let relateDocument = this.relateDocuments[row.component];
                if (relateDocument) {
                    let el = this.getRefEl('MT' + row.id);
                    el && el.initCheckStatus(relateDocument);
                }
            });
        },
        whenContainsOldChange(row) {
            let material = row.component;
            this.queryMaterialDrawingInfo(material, this.drawingContainsOld[material]);
        },
        queryMaterialDrawingInfo(material, withOld = false, row = null) {
            if (material) {
                this.drawingQuerying = material;
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_SITHMESII_PDS_URL + "/sithMomMaterialDrawingInfo/drawing/info?material=" + material + "&withOld=" + withOld,
                    commonErrorHandle: false
                }).then(response => {
                    if (response) {
                        this.materialDrawingInfo[material] = response;
                        if (row) {
                            setTimeout(() => this.initCheckedDocument(row), 300);
                        }
                    }
                }).finally(() => this.drawingQuerying = null);
            }
        },
        getDrawingList(row) {
            return this.materialDrawingInfo[row.component];
        },
        whenMaterialCheck(event) {
            this.relateMaterials = event;
            this.changed = true;
        },
        whenDocumentCheck(material, numbers) {
            this.changed = true;
            if (numbers && numbers.length > 0) {
                this.$set(this.relateDocuments, material, numbers);
            } else {
                this.$delete(this.relateDocuments, material);
            }
        },
    }
}
</script>

<style scoped>
::v-deep .custom-control-label {
    width: max-content !important;
}
</style>
